import isString from 'lodash/isString'
import { isEmail } from './isEmail'

export const addHttp = (url, allowNonHttp = true) => {
  if (!isString(url)) {
    return url
  }
  const preparedUrl = url.trim()
  if (!preparedUrl) {
    return preparedUrl
  }
  if (allowNonHttp) {
    if (isEmail(preparedUrl)) {
      return preparedUrl
    }
    if (!/^#|^[a-z]+:/.test(preparedUrl)) {
      return 'https://' + preparedUrl
    }
  }
  if (!allowNonHttp && !/^#|^(?:f|ht)tps?\:\/\//.test(preparedUrl)) {
    return 'https://' + preparedUrl
  }
  return preparedUrl
}
